module.exports = __webpack_public_path__ + "img/cladire1.fe341239.jpeg";